import React, { useEffect, useState } from "react";
import axios from "axios";
import { useI18n } from "../lib/i18n";
import NewsCard from "../components/NewsCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsPage() {
  const { t, lang } = useI18n();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${API}/news`)
      .then((r) => setNews(r.data))
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-32 pb-24 lg:pb-32 bg-[#F8F9FA] min-h-screen">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="max-w-3xl">
          <p className="overline mb-5">{t.news.overline}</p>
          <h1
            data-testid="news-page-title"
            className="font-serif text-5xl lg:text-6xl xl:text-7xl text-[#0A1428] leading-[1.05] tracking-tight font-medium"
          >
            {t.news.title}
          </h1>
          <p className="mt-6 text-[#4A5568] text-lg leading-relaxed">{t.news.subtitle}</p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {loading
            ? [1, 2, 3].map((i) => (
                <div key={i} className="bg-white h-[480px] animate-pulse" />
              ))
            : news.map((n) => <NewsCard key={n.id} article={n} lang={lang} />)}
        </div>
      </div>
    </div>
  );
}
